import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileContract } from '@fortawesome/free-solid-svg-icons';

import useHeaderTitle, { setCustomBackHandler } from '../../hooks/useHeaderTitle';
import config from '../../config';

import './TermsConditionsPage.less';

const TermsConditionsPage = () => {
	const history = useHistory();
	const location = useLocation();

	useHeaderTitle('金飯碗 Gold Rice Bowl', true);

	useEffect(() => {
		// Set custom back handler to navigate back to booking page with restored state
		setCustomBackHandler(() => {
			const bookingState = location.state?.bookingState;
			if (bookingState) {
				history.replace({
					pathname: '/booking',
					state: { restoredBookingState: bookingState }
				});
			} else {
				history.replace('/booking');
			}
		});

		return () => {
			// Cleanup will be handled by useHeaderTitle
		};
	}, [history, location]);

	return (
		<div className="terms-conditions-container">
			<div className="terms-conditions-header">
				<FontAwesomeIcon
					icon={faFileContract}
					className="terms-conditions-icon"
				/>
				<h2 className="terms-conditions-title">Terms & Conditions</h2>
				<p className="terms-conditions-effective">Effective Date: 2026-01-02 - Present</p>
			</div>

			<div className="terms-conditions-content">
				<p className="terms-conditions-intro">
					These Terms and Conditions outline the rules and regulations for the use of our website,
					services, and products (collectively referred to as the "Service").
				</p>

				<p className="terms-conditions-intro">
					By accessing or using our Service, you agree to be bound by these terms. If you disagree
					with any part, please do not use the Service.
				</p>

				<section className="terms-conditions-section">
					<h3 className="section-title">1. Use of the Service</h3>
					<ul className="section-list">
						<li>
							You must be at least 18 years old or have permission from a parent or guardian.
						</li>
						<li>
							You agree to use the Service only for lawful purposes and in accordance with these
							Terms.
						</li>
					</ul>
				</section>

				<section className="terms-conditions-section">
					<h3 className="section-title">2. User Accounts</h3>
					<ul className="section-list">
						<li>You may need to create an account to access some features.</li>
						<li>
							You are responsible for maintaining the confidentiality of your login credentials.
						</li>
						<li>You agree to provide accurate and up-to-date information.</li>
					</ul>
				</section>

				<section className="terms-conditions-section">
					<h3 className="section-title">3. Prohibited Conduct</h3>
					<p className="section-text">You agree not to:</p>
					<ul className="section-list">
						<li>Use the Service for any illegal or unauthorized purpose.</li>
						<li>Interfere with or disrupt the Service or servers.</li>
						<li>Attempt to gain unauthorized access to other accounts or systems.</li>
					</ul>
				</section>

				<section className="terms-conditions-section">
					<h3 className="section-title">4. Intellectual Property</h3>
					<p className="section-text">
						All content, trademarks, logos, and materials on the Service are owned by [Your Company
						Name] or licensed and are protected by intellectual property laws. You may not use,
						reproduce, or distribute any content without our written permission.
					</p>
				</section>

				<section className="terms-conditions-section">
					<h3 className="section-title">5. Termination</h3>
					<p className="section-text">
						We reserve the right to suspend or terminate your access to the Service at our sole
						discretion, without notice, if you violate these Terms.
					</p>
				</section>

				<section className="terms-conditions-section">
					<h3 className="section-title">6. Limitation of Liability</h3>
					<p className="section-text">
						Gold Rice Bowl Delicious Food Limited will not be liable for any indirect, incidental, special, or
						consequential damages resulting from the use or inability to use the Service.
					</p>
				</section>

				<section className="terms-conditions-section">
					<h3 className="section-title">7. Changes to These Terms</h3>
					<p className="section-text">
						We may update these Terms from time to time. Changes will be effective when posted. Your
						continued use of the Service after changes are made means you accept the new terms. We reserve the right of final decision in all matters related to these Terms.
					</p>
				</section>

				<section className="terms-conditions-section">
					<h3 className="section-title">8. Governing Law</h3>
					<p className="section-text">
						These Terms are governed by and construed in accordance with the laws of Hong Kong, and you agree to submit to the exclusive jurisdiction of its courts.
					</p>
				</section>

				<section className="terms-conditions-section">
					<h3 className="section-title">9. Contact Us</h3>
					<p className="section-text">If you have any questions about these Terms, please contact us at:</p>
					<div className="contact-info">
						{config.contact.email && (
							<p>📧 Email: <a
								href={`mailto:${config.contact.email}`}
								className="contact-link"
							             >{config.contact.email}</a></p>
						)}
						{config.contact.phone && (
							<p>📞 Phone: <a
								href={`tel:${config.contact.phone}`}
								className="contact-link"
							             >{config.contact.phone}</a></p>
						)}
						{config.contact.address && (
							<p>🏢 Address: <span className="contact-text">{config.contact.address}</span></p>
						)}
					</div>
				</section>
			</div>
		</div>
	);
};

export default TermsConditionsPage;
